var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.637 20.4437L9.58426 20.4927C9.24787 20.8686 8.83867 21.1723 8.38145 21.3854C7.92422 21.5984 7.42849 21.7164 6.9243 21.7323C4.95006 21.7323 3.51458 20.2478 3.51458 18.202C3.51458 16.1561 4.95006 14.6755 6.9243 14.6755C7.42849 14.6913 7.92422 14.8093 8.38145 15.0224C8.83867 15.2354 9.24787 15.5391 9.58426 15.915L9.637 15.9678L10.9067 14.4268L10.8728 14.3891C10.4123 13.8011 9.82207 13.3274 9.14823 13.0052C8.47439 12.683 7.73518 12.5209 6.98835 12.5317C5.50775 12.4993 4.06944 13.0267 2.96074 14.0086C1.86466 15.13 1.25098 16.6358 1.25098 18.2039C1.25098 19.7719 1.86466 21.2778 2.96074 22.3991C4.06847 23.3826 5.50744 23.9103 6.98835 23.876C7.73478 23.8867 8.4736 23.7249 9.14732 23.4034C9.82105 23.0819 10.4115 22.6093 10.8728 22.0224L10.9067 21.9809L9.637 20.4437Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4369 12.6982H12.1914V23.6583H14.4369V12.6982Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2304 21.2695C22.7391 21.6022 22.1654 21.7926 21.5727 21.8196C20.8455 21.8196 20.5215 21.4428 20.5215 20.5838V14.7703H22.8084V12.7056H20.5215V9.2959L18.3174 10.4714V12.7056H16.4336V14.7703H18.3174V20.9567C18.3174 22.6409 19.3158 23.79 20.8078 23.8202C21.5074 23.8566 22.2017 23.682 22.8009 23.3191H22.8235L23.3811 21.1979L23.2304 21.2695Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 12.6982H25.0879V23.6583H27.3334V12.6982Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6562 10.7731C27.6512 9.34048 26.3158 8.17101 24.7632 7.36364C23.2106 6.55628 21.4863 6.13477 19.7363 6.13477C17.9863 6.13477 16.2621 6.55628 14.7094 7.36364C13.1568 8.17101 11.8215 9.34048 10.8164 10.7731L10.7109 10.92H13.2918L13.3219 10.8899C14.1452 10.0144 15.1391 9.31663 16.2422 8.8397C17.3454 8.36277 18.5345 8.11673 19.7363 8.11673C20.9382 8.11673 22.1273 8.36277 23.2304 8.8397C24.3336 9.31663 25.3274 10.0144 26.1507 10.8899L26.1809 10.92H28.7617L28.6562 10.7731Z",
    fill: "#ED1C2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 17.7305,
    fill: "white",
    transform: "translate(1.25 6.13477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/씨티-30.4cf18ac90cb2b3e3594bb8a6cfcfaef1.svg";
export { ForwardRef as ReactComponent };